@for (preference of availablePreferences; track preference) {
  <div class="preference-container">
    <p>{{ preference.preference }}</p>
    @for (value of preference.values; track value) {
      <button
        class="preference-btn"
        [class]="isActive(value, preference.preferenceShort) ? 'active' : ''"
        (click)="togglePreference(preference, value)"
        >
        {{ value }}
      </button>
    }
  </div>
}

<button class="btn btn-primary btn-preferences" type="button" (click)="saveCustomerPreferences()">{{ submitBtnText }}</button>